import React from "react";
import Header from "../common/Header";
import { notificaitonPageData } from "../common/Helper";
import { SearchIcon } from "../common/Icon";

const NotificaitonPage = () => {
  return (
    <>
      <div className="px-4 lg:px-0 overflow-x-hidden w-full mr-4">
        <div className=" bg-light_purple7 px-5 rounded-2xl h-[calc(100vh-32px)] relative overflow-y-auto overflow-x-hidden">
          <div className=" overflow-hidden">
            <Header text="Notification" />
          </div>
          <div className=" bg-white rounded-[20px] shadow-my_contacts_tabs_shadow px-3 md:px-6 pt-6 mt-1 ">
            <div className="flex border border-solid border-[#F2F2F2] 3xl:border-gray ps-4 py-2 3xl:py-[10px]  items-center rounded-[32px] max-w-[343px] mb-8">
              <span className="opacity-40">
                <SearchIcon />
              </span>
              <input
                className="font-normal text-xs 3xl:text-[16px] text-black  bg-transparent placeholder:text-gray placeholder:font-normal px-[10px] outline-none w-11/12"
                type="text"
                placeholder="Search here..."
              />
            </div>
            <div className=" h-[calc(100vh-280px)] sm:h-[calc(100vh-220px)] md:h-[calc(100vh-230px)] overflow-y-auto productivity_scrollbar_line">
              {notificaitonPageData.map((value, index) => (
                <div
                  className=" rounded-xl bg-light_purple7 pt-8 pb-7 px-4 md:px-6 my-[10px] w-full "
                  key={index}>
                  <div className="flex items-center">
                    <span className=" notification-page-Icon">
                      {value.notificationIcon}
                    </span>
                    <p className="text-sm md:text-[18px] font-normal leading-[137%] pl-3 md:pl-8 xl:max-w-[680px]">
                      {value.notificationText}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotificaitonPage;
